
import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { SizeTableService } from "@/services/size-table-service";
import { ProductSizeStock } from "@/models/base";
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { printHumanFloat } from "@/utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			loading: false,
			sizeStocks: [] as ProductSizeStock[],
			loadedForId: 0
		};
	},
	props: {
		item: {
			type: Object as () => any,
			required: true
		}
	},
	computed: {
		locationConfig():StockLocationConfig {
			return DossierConfigService.getStockLocationConfig();
		},
		locations():{id:number, name:string}[] {
			let result:{id:number, name:string}[] = [];
			for (let id = 1; id <= StockLocationConfig.MAX_ID; id++) {
				if (this.locationConfig.getLocationAlias(id).match(/^\s*$/)) {
					continue;
				}
				result.push({id, name: this.locationConfig.getLocationName(id)});
			}
			return result;
		},
		summary():string {
			let inStock = this.sizeStocks.filter(s=>s.getTotalInStock() > 0);
			if (inStock.length == 0) return "";
			return inStock.map(s=>`${s.SizeTableEntry ? s.SizeTableEntry.Name : "?"} (${this.print(s.getTotalInStock())})`).join(", ");
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item: {
			immediate: true,
			handler(){
				this.load();
				this.$emit("summary", this.summary);
			}
		}
	},
	methods: {
		print(value:number):string {
			return printHumanFloat(value || 0, 0);
		},
		async load(){
			let id = this.item.ID;
			if (!id || this.loadedForId == id) return;
			this.loadedForId = id;
			this.sizeStocks = [];
			if (!this.item.SizeTableID) return;
			this.loading = true;
			try {
				let result = await SizeTableService.getProductSizeStock(id);
				if (this.item.ID != id) return;
				this.sizeStocks = result;
			} catch (err) {
				this.sizeStocks = [];
			} finally {
				this.loading = false;
			}
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
